import { observer } from 'mobx-react';
import { Fragment, useEffect } from 'react';
import PublishedCollectionModal from '../../../../../../../PublishedCollectionModal';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';
import { ConfirmingCancelState } from './ConfirmingCancelState';
import Publishing from './Publishing';
import Waiting from './Waiting';

function SaveCollection() {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      switch (previewStore.state.kind) {
        case 'ready':
        case 'recommendations-incoming':
        case 'publishing':
        case 'creating':
        case 'save-and-editing':
          event.preventDefault();
          return '';
        default:
          return;
      }
    };

    const handlePopState = (event: PopStateEvent) => {
      switch (previewStore.state.kind) {
        case 'ready':
        case 'recommendations-incoming':
        case 'publishing':
        case 'creating':
        case 'save-and-editing':
          event.preventDefault();
          previewStore.showCancelConfirmation();
          return;
        case 'confirming-cancel':
        case 'confirming-cancel-from-publish':
        case 'confirming-cancel-from-create':
        case 'confirming-cancel-from-save-and-edit':
          event.preventDefault();
          return;
        default:
          return;
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.history.pushState({ modalOpened: false }, '');

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  switch (previewStore.state.kind) {
    case 'error':
    case 'loading':
    case 'waiting':
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
    case 'discarding-changes':
    case 'ready':
    case 'recommendations-incoming':
      return <Waiting />;
    case 'publish-celebration':
    case 'save-celebration':
      return <PublishedCollectionModal state={previewStore.state} />;
    case 'publishing':
    case 'creating':
    case 'save-and-editing':
      return <Publishing state={previewStore.state} />;
    case 'confirming-cancel':
      return <ConfirmingCancelState />;
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-save-and-edit':
      return (
        <Fragment>
          <Publishing state={previewStore.state} />
          <ConfirmingCancelState />
        </Fragment>
      );
  }
}

export default observer(SaveCollection);
